/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from "@angular/core";
import { ISelectSystemFacade } from "../../../../../data-access/src/lib/domain/facades-models/select-system-facade-interface";
import { Store } from "@ngrx/store";
import { selectManageMode, selectSystemInfo } from "../tool-belt.selector";
import { LocalStorageService } from "../../../../../utils/src/lib/local-storage/local-storage.service";
import { UpdateSystemInfoSuccess } from "../toolbelt.actions";
import { GlobalConstants } from "../../constants/global-constants";

@Injectable({
    providedIn: 'root'
})
export class SelectSystemFacade implements ISelectSystemFacade{
    constructor(private store: Store, private localStorageService: LocalStorageService){}

    selectManageMode() : any {
        return this.store.select(selectManageMode);
     }

    selectSystemInfo() : any {
        return this.store.select(selectSystemInfo);
    }

    updateSystemInfo(data: any) {
        this.store.dispatch(UpdateSystemInfoSuccess({ systemInfo: data }));
    }

    getSystemState() : any {
        return this.localStorageService.getStorage(GlobalConstants.SYSQUE_ELECTRICAL_STATE_KEY);
    }
}